import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { get } from "api";

const useNavigateToPlatformCompleteProfile = () => {
  const navigate = useNavigate();

  const redirectWithTheme = useCallback(
    async ({
      platformId,
      locationId,
      referralCode,
      searchQuery,
    }: {
      platformId: string;
      locationId?: string;
      referralCode?: string;
      searchQuery?: string;
    }) => {
      const params = new URLSearchParams({
        platformId,
      });

      if (locationId) {
        params.append("locationId", locationId);
      }

      if (referralCode) {
        params.append("referralCode", referralCode);
      }

      try {
        const platformTheme = await get(
          "/multi-platform/platform/{platformId}/theme",
          { platformId }
        );

        if (platformTheme?.logoImageUrl) {
          params.append("platformImageUrl", platformTheme.logoImageUrl);
        }
      } catch (error) {
        throw new Error("Get platform theme request failed.");
      }

      const redirectUrl = `/signin/location?${params.toString()}`;

      navigate(redirectUrl, {
        state: { zip: searchQuery },
      });
    },
    [navigate]
  );

  return redirectWithTheme;
};

export default useNavigateToPlatformCompleteProfile;
